import React from 'react'

import { Container, OpeningRow, Wrapper } from './Styles'

interface Props {
  children: React.ReactNode
}

const RoutesAside = ({ children }: Props) => {
  return (
    <Container>
      <Wrapper>
        <OpeningRow>
          <p>Route</p>
          <p>Total time </p>
        </OpeningRow>
        {children}
      </Wrapper>
    </Container>
  )
}

export default React.memo(RoutesAside)
